import React from 'react';
import { Fade, Zoom } from 'react-reveal';

const Project = ({ item }) => {
  return (
    <div key={item.id} className='flex flex-col items-center border border-transparent text-center p-4 rounded hover:border-slate-100'>
      <Fade bottom duration={1500}>
      <div className='mb-8'>
        <img className='rounded-2xl h-60 w-72 object-cover overflow-hidden hover:scale-110 hover:duration-300 ' src={item.image} alt='' />
      </div>
      </Fade>
      <p className='capitalize text-accent text-sm mb-3'>{item.category}</p>
      <Fade left>
      <h3 className='text-2xl font-semibold capitalize mb-3'>{item.name}</h3>
      </Fade>
      <Fade right>
      <p className='text-base max-w-md'>{`${item.description.slice(0,100)}...`}</p>
      </Fade>
      <Zoom>
      <div className="">
        {/* <a href={item?.githubClient} target="_blank" rel="noopener noreferrer"><button className="bg-accent hover:bg-rose-700 my-5 text-white px-7 py-2 mx-2 rounded">Github Client</button></a>
        <a href={item?.githubServer} target="_blank" rel="noopener noreferrer"><button className="bg-accent hover:bg-rose-700 my-5 text-white px-7 py-2 mx-2 rounded">Github Server</button></a> */}
        <a href={item?.LiveLink} target="_blank" rel="noopener noreferrer"><button className="bg-accent hover:bg-rose-700 my-5 text-white px-7 py-2 mx-2 rounded">Live Link</button></a>
      </div>
      </Zoom>
    </div>
  );
};

export default Project;
